import { Currency } from '@kodiak-finance/sdk-core'
import { createContext } from 'react'

import { VaultConfig } from '../IslandManagementCard/strategies/config/vaultConfigs'
import { VaultStrategy } from '../IslandManagementCard/strategies/vault'
import { IslandContextType } from './IslandContextType'

const defaultVaultStrategy: VaultStrategy = {
  supportsZapping: false,
  supportsAutoCompound: false,
  get routerAddress() {
    return ''
  },
  async addLiquidityDoubleSided() {
    throw new Error('Not initialized')
  },
  async addLiquidityNative() {
    throw new Error('Not initialized')
  },
  async addLiquiditySingleSided() {
    throw new Error('Not initialized')
  },
  async withdrawLiquidity() {
    throw new Error('Not initialized')
  },
  async stakeLiquidity() {
    throw new Error('Not initialized')
  },
  async unstakeLiquidity() {
    throw new Error('Not initialized')
  },
}

// Create a default vault config for the initial context
const defaultVaultConfig: VaultConfig = {
  supportsAutoCompound: false,
  displayName: '',
  routerType: 'island',
  transactionLabels: {
    addLiquidity: '',
    depositOnly: '',
    withStaking: '',
  },
}

const initialContext: IslandContextType = {
  currencyA: null as unknown as Currency,
  currencyB: null as unknown as Currency,
  wrappedNativeCurrency: null,
  feeAmount: 0,
  poolType: 'Island', // Default pool type
  islandId: '',
  router: null,
  vaultStrategy: defaultVaultStrategy,
  vaultConfig: defaultVaultConfig,
  // Optional properties can be omitted or set to undefined
  stakingData: {
    stakingType: 'none',
    baultAddress: undefined,
    kodiakFarmAddress: undefined,
    rewardVaultAddress: undefined,
  },
  config: undefined,
  farmAddress: undefined,
  rewardVault: undefined,
  rewardVaultRewardToken: undefined,
  baultAddress: undefined,
  stakingType: undefined,
  poolApiResponse: undefined,
  showMigrationOption: undefined,
  isRewardVaultStakingDisabled: undefined,
}

export const IslandContext = createContext<IslandContextType>(initialContext)
